// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"e191ef14","354":"fc051819","535":"d0020661","991":"954642f1"}[chunkId] + ".chunk.js";
};